import React, { useState } from 'react';

function ApiTester() {
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const testApi = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const res = await fetch('https://portail-crc-test.portnet.ma/api/preavisArrivee/byNumConteneurAndNumPreavis', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJlMTcyNjUxZGQ2YmY0NjUyYTYzMmQ0OTBmNTgxYWI4OSIsImlhdCI6MTc2NDk0MDUzMSwiZXhwIjoxNzY1MTk5NzMxLCJ1c2VybmFtZSI6ImFkbWluMyIsImZpcnN0bmFtZSI6Im0iLCJsYXN0bmFtZSI6Im0iLCJlbWFpbCI6ImFjaGFnZGFsaS5leHRlcm5lQHBvcnRuZXQubWEiLCJyb2xlcyI6WyJST0xFX1ZVUE9SVFVBUklBX0FETUlOIl19.plMJTHzESmO2ZV8AeKoC72_dUgV-rMRQ8nfyC_SR9JU'
        },
        body: JSON.stringify({
          numConteneur: "AZERTY",
          numPreavisArrivee: "1234567891234"
        })
      });

      const data = await res.json();
      setResponse(data);
      console.log('Response:', data);
    } catch (err) {
      setError(err.message);
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>API Tester</h2>
      <button onClick={testApi} disabled={loading}>
        {loading ? 'Loading...' : 'Test API'}
      </button>
      
      {error && (
        <div style={{ color: 'red', marginTop: '20px' }}>
          <strong>Error:</strong> {error}
        </div>
      )}
      
      {response && (
        <div style={{ marginTop: '20px' }}>
          <strong>Response:</strong>
          <pre style={{ background: '#f4f4f4', padding: '10px', borderRadius: '5px' }}>
            {JSON.stringify(response, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}

export default ApiTester;